import { render, staticRenderFns } from "./myMediaPublish.vue?vue&type=template&id=67489150&scoped=true&"
import script from "./myMediaPublish.vue?vue&type=script&lang=js&"
export * from "./myMediaPublish.vue?vue&type=script&lang=js&"
import style0 from "@assets/css/mediaPublish/myPublish.less?vue&type=style&index=0&id=67489150&lang=less&scoped=true&"
import style1 from "./myMediaPublish.vue?vue&type=style&index=1&id=67489150&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67489150",
  null
  
)

component.options.__file = "myMediaPublish.vue"
export default component.exports